import { render } from "./icon-calendar.vue?vue&type=template&id=05ad5fe8"
import script from "./icon-calendar.vue?vue&type=script&lang=js"
export * from "./icon-calendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__